import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import type { RenterProfile, ZrmListingInfo, ZrmUserInfo } from '@zg-rentals/clickstream';
import { tracker as CLICKSTREAM } from '@zg-rentals/clickstream';
import { tracker as COMSCORE } from '@zg-rentals/comscore';

export const analytics = defineAnalytics({ COMSCORE, CLICKSTREAM });

export const trackComscoreEvent = analytics.createTrackEvent('COMSCORE');

export const trackEvent = analytics.createTrackEvent('CLICKSTREAM');

export const trackBaseEvent = analytics.createTrackEvent('CLICKSTREAM');

export const trackUserEvent = analytics.createTrackEvent<'CLICKSTREAM', ZrmUserInfo>('CLICKSTREAM');

export const trackListingEvent = analytics.createTrackEvent<'CLICKSTREAM', ZrmUserInfo & ZrmListingInfo>('CLICKSTREAM');

export const trackRenterProfileEvent = analytics.createTrackEvent<
  'CLICKSTREAM',
  ZrmUserInfo & { renter_profile: RenterProfile['renter_profile'] | null }
>('CLICKSTREAM');
